import { useQuery, UseQueryResult } from 'react-query';

import { useAuth } from './useAuth';
import { getPermissionGroupCode } from 'src/utils/urls';

import { PermissionGroupCodeType } from 'src/types/permissionGroupCode';

async function fetchPermissionGroupCode({
  token,
  tokenType,
}: TVaribles): Promise<TResult> {
  const response = await fetch(getPermissionGroupCode, {
    method: 'GET',
    headers: {
      Authorization: `${tokenType} ${token}`,
    },
  });
  return response.json();
}

export type TResult = {
  Data: Array<PermissionGroupCodeType> | undefined;
  IsSuccess: boolean;
  StatusCode: number;
};
export type TError = { message: string };
export type TVaribles = {
  token: string;
  tokenType: string;
};

function useGetPermissionGroupCode(): UseQueryResult<TResult, TError> {
  const { token, tokenType } = useAuth();
  return useQuery(
    ['permission_group_code'],
    async () => {
      return fetchPermissionGroupCode({
        token,
        tokenType,
      });
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetPermissionGroupCode };
